module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/160-northern-marianas-islands-201996c5f431bd71715cc793184b94c5.svg";